import { render } from "./NoTicketComponent.vue?vue&type=template&id=78827887&scoped=true&ts=true"
import script from "./NoTicketComponent.vue?vue&type=script&lang=ts"
export * from "./NoTicketComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78827887"]])

export default __exports__